var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 42237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.08398 15C3.08398 8.41922 8.41873 3.08447 14.9995 3.08447C21.5802 3.08447 26.915 8.41922 26.915 15C26.915 21.5807 21.5802 26.9155 14.9995 26.9155C8.41873 26.9155 3.08398 21.5807 3.08398 15ZM14.9995 0.0844727C6.76188 0.0844727 0.0839844 6.76237 0.0839844 15C0.0839844 23.2376 6.76188 29.9155 14.9995 29.9155C23.2371 29.9155 29.915 23.2376 29.915 15C29.915 6.76237 23.2371 0.0844727 14.9995 0.0844727ZM8.69287 22.3396C8.68718 22.3509 8.68423 22.3568 8.68484 22.3572C8.6855 22.3577 8.69035 22.3516 8.70047 22.339C8.72947 22.303 8.80171 22.213 8.9424 22.0675C9.16268 21.8396 9.47983 21.5485 9.87964 21.2384C10.6845 20.6143 11.7635 19.9603 12.9882 19.5712C14.2024 19.1855 15.5282 19.0684 16.8911 19.4599C18.2483 19.8497 19.7747 20.7816 21.3338 22.7175L23.6703 20.8358C21.7945 18.5067 19.7705 17.1656 17.7193 16.5764C15.6738 15.9889 13.733 16.1868 12.0798 16.712C10.4371 17.2339 9.048 18.087 8.04115 18.8678C7.53511 19.2602 7.11056 19.6461 6.7854 19.9825C6.50688 20.2706 6.17831 20.6462 6.00391 21.0097L8.70864 22.3075C8.70223 22.3209 8.69687 22.3316 8.69287 22.3396Z",
    fill: "#FF0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadIcon);
export default __webpack_public_path__ + "static/media/SadIcon.07ee22e97f03d7321cebc497d53a3634.svg";
export { ForwardRef as ReactComponent };